
export const CHANGE_PAGE = "[FULL REPORT TABLE] CHANGE_PAGE";
export const LOAD_TOP_WORDS_PAGINATED = "[FULL REPORT TABLE] LOAD_TOP_WORDS_PAGINATED";
export const SEARCH_CHANGE = "[FULL REPORT TABLE] PRIMARY_SEARCH_CHANGE";

export const CHANGE_TARGET_PAGE = "[FULL REPORT TABLE] CHANGE TARGET PAGE";

export const DOWNLOAD_TOP_WORDS = '[FULL REPORT TABLE] DOWNLOAD';
export const DOWNLOAD_TOP_WORDS_DONE = '[FULL REPORT TABLE] DOWNLOAD_DONE';